import { SET_PAGINATION_PAGE_CLIENTS } from '../types';

const initialState = {
  page: 1,
  totalSize: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PAGINATION_PAGE_CLIENTS:
      return {
        ...state,
        page: action.page,
      };
    case 'SET_TOTAL_SIZE':
      return {
        ...state,
        totalSize: action.totalSize,
      };
    default:
      return state;
  }
};
